module.exports = __webpack_public_path__ + "img/syukyaku-landing-pa002.cc0f9d3d.png";